import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { transactionFilterList } from "../../../../utils/Constants";
import { capitalizeFirstLetter, formateDateWithMonth, writeMyExcel } from "../../../../utils/commonfunction";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import * as transactionServices from "../../services/transaction.services";
import { useTranslation } from "react-i18next";
import CustomRangepicker from "../../common/rangepicker";
// import { Tooltip, Whisper } from "rsuite";
import { getCurrencySymbol } from "../../../../utils/commonfunction";

const TransactionsList = () => {
  const params = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [dateRange, setDateRange] = useState({});
  const [datalength, setDataLength] = useState();
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [businessName, setBusinessName] = useState("");
  const [userName, setUserName] = useState("");
  const breadcrumbs = [
    { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard" },
    { title: "Transactions", url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("userName", userName);
        formData.append("businessName", businessName);
        formData.append("status", selectedStatus);
        if (dateRange?.start && dateRange?.end) {
          formData.append("startDate", new Date(dateRange.start).toISOString());
          formData.append("endDate", new Date(dateRange.end).toISOString());
        }

        transactionServices
          .List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            setList(data && data.data && data.data.list ? data.data.list : []);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);

    return () => clearTimeout(getData);
  }, [location, sorting, userName, businessName, selectedStatus, dateRange, params.pgno]);

  const viewfunction = (row) => {
    navigate(`/admin/user/view/${row._id}`);
  };

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };
  // search or filer end

  const resetFilter = (e) => {
    e.preventDefault();
    setSelectedStatus("");
    setDateRange({});
    setUserName("");
    setBusinessName("");
    prepareSearch();
    setSearch({});
    // reset customrangepicker & customstatusfilter state using jquery//
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };

  const handleExportToExcel = () => {
    // Prepare the data for export
    const headers = ["User Name", "User Phone No.", "Business Name", "Business Phone Number", "Transaction ID", "Total Amount", "Net Paid Amount", "Offer Percentage", "Created At", "Status"];

    const rows = list.map((row) => [
      row?.user?.fullName ? capitalizeFirstLetter(row.user.fullName) : "N/A",
      row?.user?.phone_number ? row?.user?.phone_number?.fullNumber : "N/A",
      row?.business?.business_name ? capitalizeFirstLetter(row.business.business_name) : "N/A",
      row?.business?.phone_number ? row?.business?.phone_number?.fullNumber : "N/A",
      row?.transactionID ? row.transactionID : "N/A",
      row?.totalAmount ? getCurrencySymbol(row.currency, row.totalAmount) : "N/A",
      row?.netPay ? getCurrencySymbol(row.currency, row.netPay) : "N/A",
      row?.offerPercentage ? row.offerPercentage + "%" : "N/A",
      row?.createdAt ? formateDateWithMonth(row.createdAt) : "N/A",
      row.status,
    ]);

    writeMyExcel([headers, ...rows], `${t("label_rating_report")}.xlsx`);
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card overflow-hidden">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">Transaction Management</h6>
              <div className="d-flex align-items-center">
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                      setDateRange(e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    className="cp"
                    data={transactionFilterList}
                    prepareSearch={(key, val) => {
                      prepareSearch(key, val);
                      setSelectedStatus(val);
                    }}
                  />
                </div>
                <button type="reset" value="Reset" onClick={resetFilter} className="btn btn-warning float-right mr-2 ripple">
                  {t("Reset filter")}
                </button>
                <button type="" value="" class="btn ripple btn-main-primary signbtn" onClick={() => handleExportToExcel()}>
                  Export Report
                </button>
              </div>
            </div>
            <div className="d-flex">
              <div className="form-group mb-0 me-3 mb-3">
                <div className="form-group mb-0 rangepicker_container filter_design">
                  <i className="fa fa-search calender_icon"></i>
                  <input
                    type="search"
                    className="form-control"
                    value={userName}
                    placeholder={"User Name"}
                    onChange={(e) => {
                      setUserName(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="form-group mb-0 me-3 mb-3">
                <div className="form-group mb-0 rangepicker_container filter_design">
                  <i className="fa fa-search calender_icon"></i>
                  <input
                    type="search"
                    className="form-control"
                    value={businessName}
                    placeholder={"Business Name"}
                    onChange={(e) => {
                      setBusinessName(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table id="example-input" className="table table-bordered card-table border-top text-nowrap w-100">
                {/* <table id="example-input" className="table table-bordered border-t0 key-buttons text-nowrap w-100"> */}
                <thead>
                  <tr>
                    <th className="sr_head">{t("admin.faq.list_heading_sno")}</th>
                    <th>
                      <div className="sorting_column">
                        <span>Transaction ID</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>User Name</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>User Email</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>User Phone Number</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Business Name</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Business Email</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Business Phone Number</span>
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Total Amount</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="totalAmount" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Net Paid Amount</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="netPay" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Offer Percentage</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="offerPercentage" />
                      </div>
                    </th>
                    <th className="created_head">
                      <div className="sorting_column">
                        <span>{t("Created Date")}</span>
                        <Sorting sort={sorting} defaultSorting={defaultSorting} handleSort={handleSort} column="createdAt" />
                      </div>
                    </th>
                    <th className="status_head">{t("Status")}</th>
                    {/* <th className="action_head">{t("Action")}</th> */}
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={13}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length > 0 ? (
                        list.map((row, i) => {
                          return (
                            <tr key={i}>
                              <td>{row ? (page - 1) * itemperpage + i + 1 : null}</td>
                              <td>{row?.transactionID || "N/A"}</td>
                              <td>{capitalizeFirstLetter(row?.user.fullName) || "N/A"}</td>
                              <td>{row?.user.email || "N/A"}</td>
                              <td>{row?.user.phone_number ? row?.user.phone_number?.fullNumber : "N/A"}</td>
                              <td>{capitalizeFirstLetter(row?.business.business_name) || "N/A"}</td>
                              <td>{row?.business.email || "N/A"}</td>
                              <td>{row?.business.phone_number ? row?.business.phone_number?.fullNumber : "N/A"}</td>
                              <td>{getCurrencySymbol(row.currency, row.totalAmount) || "N/A"}</td>
                              <td>{getCurrencySymbol(row.currency, row.netPay) || "N/A"}</td>
                              <td>{row?.offerPercentage + "%" || "N/A"}</td>
                              <td>{row?.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                              <td>{row.status}</td>
                              {/* <td>
                                <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                  <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                    <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>View</Tooltip>}>
                                      <button
                                        type="button"
                                        className="btn view"
                                        onClick={() => {
                                          viewfunction(row);
                                        }}>
                                        <i className="ri-eye-fill"></i>
                                      </button>
                                    </Whisper>
                                  </div>
                                </div>
                              </td> */}
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={13} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div className="" id="example1_info" role="status" aria-live="polite">
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? <CustomPagination datalength={datalength} itemperpage={itemperpage} setPage={setPage} currentPage={page} pageRoute={[{ name: "User", path: "/admin/user/list" }]} /> : ""}
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default TransactionsList;

function StatusFilter(props) {
  const { t } = useTranslation();
  const showFilterlistNew = props.data && props.data.length > 0 ? props.data : [];

  const handleChange = (e) => {
    if (e.target.value) {
      props.prepareSearch("status", e.target.value);
    } else {
      props.prepareSearch("status", "");
    }
  };

  return (
    <div className="form-group mb-0 filter_icon_container filter_design">
      <i className="fa fa-filter mr-2 filter_icon"></i>
      <div className="select-down-arrow">
        <select className="form-control cp" onChange={handleChange} id="defaultstatus">
          {showFilterlistNew &&
            showFilterlistNew.length > 0 &&
            showFilterlistNew.map((option, i) => {
              return (
                <option key={i} value={option.status__id}>
                  {t(option.name)}
                </option>
              );
            })}
        </select>
      </div>
    </div>
  );
}
